import { declareEvent } from "@cloudextend/common/events";
export const cefiInitialized = declareEvent("CEFI:State:Initialized");

export * from "./connection/events";
export * from "./identity/events";
export * from "./session-lifetime/events";
export * from "./subscription/events";
export * from "./logout/events";
